import { Avatar, Button, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { PurpleSortIcon } from 'Images';
import { useDictionary, useIsDesktop } from 'Hooks';
import { DocumentsOrder } from '../DocumentsMain';

interface IDocumentsSortButton {
  foundDocuments: number;
  sort: () => void;
  sortingOrder: DocumentsOrder;
}

export const DocumentsSortButton = ({
  foundDocuments,
  sort,
  sortingOrder,
}: IDocumentsSortButton) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Documents);
  const isDesktop = useIsDesktop();

  return (
    <Stack direction={'row'} justifyContent='space-between' alignItems='center'>
      <Typography component='h2' variant='body3'>
        {dictionary.foundDocuments(foundDocuments)}
      </Typography>
      <Button
        onClick={sort}
        disableTouchRipple
        sx={{ '&:hover': { background: 'transparent' } }}
        role='switch'
        aria-checked={sortingOrder === DocumentsOrder.Oldest}
      >
        <Avatar
          alt={''}
          src={PurpleSortIcon}
          sx={{
            marginRight: '5px',
            width: isDesktop ? '26px' : '24px',
            height: isDesktop ? '26px' : '24px',
            rotate: sortingOrder === DocumentsOrder.Oldest ? '180deg' : '0deg',
            transition: 'rotate 0.3s ease',
          }}
        />
        <Typography variant='body2' color='primary' aria-live={'assertive'}>
          {dictionary.sort(sortingOrder !== DocumentsOrder.Oldest)}
        </Typography>
      </Button>
    </Stack>
  );
};
